import { computed, inject, Injectable, signal } from '@angular/core';
import {
  IShiftInfoDTO,
  IUserData,
  IUserInfoDetailsDTO,
  IUserPfEsiDetailsDTO,
} from '@bashaquerizwan/azaadi-packages';
import { UserApiService } from './user.api.service';
import { IGenericResponse } from 'src/app/modules/home/pages/dashboard/models/Generic';
import { Observable, Subject } from 'rxjs';
import { USER_INFO_LOCAL_STORAGE_KEY } from '@shared/utils/constant';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly _userApiService = inject(UserApiService);
  private _loggedInUser = signal<IUserData | null>(
    localStorage.getItem(USER_INFO_LOCAL_STORAGE_KEY)
      ? JSON.parse(localStorage.getItem(USER_INFO_LOCAL_STORAGE_KEY)!).tUser
      : null,
  );
  public readonly isLoggedIn = computed(() => !!this._loggedInUser());

  public readonly loggedInUser = this._loggedInUser.asReadonly();
  private userUpdateSource = new Subject<void>();
  userUpdated$ = this.userUpdateSource.asObservable();

  notifyUserUpdate() {
    this.userUpdateSource.next();
  }
  setLoggedInUser(user: IUserData | null) {
    this._loggedInUser.set(user);
  }

  getUserDetailsService(): Observable<IGenericResponse<IUserInfoDetailsDTO>> {
    return this._userApiService.getUserDetailsApiService();
  }

  getPfEsiDetailsService(): Observable<IGenericResponse<IUserPfEsiDetailsDTO>> {
    return this._userApiService.getPfEsiDetailsApiService();
  }
  getLoggedInUser() {
    return this._loggedInUser();
  }
  getDocumentsService() {
    return this._userApiService.getDocumentsApiService();
  }
  updateUserService(requestBody: any) {
    return this._userApiService.updateUserApiService(requestBody);
  }
  getShiftByUserIdService(): Observable<IGenericResponse<IShiftInfoDTO[]>> {
    return this._userApiService.getShiftByUserIdApiService();
  }
}
